// the two arrays must be the same length
export interface GoogleAdWordsMetricChartData {
  labels: string[];
  values: number[];
}

export interface GoogleAdWordsData {
  metrics: GoogleAdWordsMetrics;
  campaigns: GoogleAdWordsCampaign[];
  adGroups: GoogleAdWordsAdGroup[];
  keywords: GoogleAdWordsKeywords[];
}

export interface GoogleAdWordsMetrics {
  clicks: number;
  CTR: number;
  impressions: number;
  cost: number;
  CPC: number;
  CPM: number;
  conversions: number;
  costPerConversion: number;
  conversionRate: number;
}

export interface GoogleAdWordsCampaign extends GoogleAdWordsMetrics {
  id: string;
  name: string;
}

export interface GoogleAdWordsAdGroup extends GoogleAdWordsMetrics {
  id: string;
  name: string;
  campaignID: string;
  campaignName: string;
}

export interface GoogleAdWordsKeywords extends GoogleAdWordsMetrics {
  id: string;
  keywordPlacement: string;
  campaignID: string;
  campaignName: string;
  adGroupID: string;
  adGroupName: string;
  criteriaType: string;
}

export const mockGoogleAdWordsMetrics: GoogleAdWordsMetrics = {
  conversionRate: 0.06937291527685123,
  CPC: 0.8780917324883257,
  CPM: 110.48006605673999,
  clicks: 1499,
  conversions: 103.99,
  cost: 1316.2595070000002,
  costPerConversion: 12.657558486392926,
  CTR: 0.12581836494879972,
  impressions: 11914,
};

export const mockGoogleCampaign: GoogleAdWordsCampaign = {
  id: '10622011409',
  name: "Jan-Mar '22",
  CTR: 0.12581836494879972,
  clicks: 1499,
  cost: 1316.2595070000002,
  CPC: 0.8780917324883257,
  CPM: 1.23,
  conversions: 103.99,
  costPerConversion: 12.657558486392926,
  impressions: 11914,
  conversionRate: 37.882571428571424,
};

export const mockGoogleAdWordsAdGroup: GoogleAdWordsAdGroup = {
  id: '107831344791',
  name: 'Hotels in Lincoln',
  campaignID: '10622011409',
  campaignName: "Jan-Mar '22",
  CTR: 0.12581836494879972,
  clicks: 1499,
  cost: 1316.2595070000002,
  CPC: 0.8780917324883257,
  CPM: 1.23,
  conversions: 103.99,
  costPerConversion: 12.657558486392926,
  impressions: 11914,
  conversionRate: 37.882571428571424,
};

export const mockGoogleAdWordsKeywords: GoogleAdWordsKeywords = {
  id: '3000000',
  keywordPlacement: 'Content',
  campaignID: '10622011409',
  adGroupID: '107831344791',
  campaignName: "Jan-Mar '22",
  adGroupName: 'Hotels in Lincoln',
  criteriaType: 'Keyword',
  CTR: 0.28,
  clicks: 2,
  cost: 1.269507,
  CPC: 0.634754,
  CPM: 1.23,
  conversions: 0,
  costPerConversion: 0,
  impressions: 706,
  conversionRate: 0,
};

export const mockGoogleAdWordsData: GoogleAdWordsData = {
  metrics: mockGoogleAdWordsMetrics,
  campaigns: [mockGoogleCampaign],
  adGroups: [mockGoogleAdWordsAdGroup],
  keywords: [mockGoogleAdWordsKeywords],
};
